<template>
<div>
<div v-if="!packagePurchased">
	<widget v-for="(product,index) in products" :title="product.title" :key="'widget_' + index">
		<div class="inner">
			<hr>
			<div class="d-flex justify-content-between align-items-center">
				<div>
					<span v-if="product.num_installments <= 1">One-time fee of</span>
					<span v-else>{{ product.num_installments }} monthly installments of</span>
					<div class="price">$ {{ product.price_cad }}</div>
					
				</div>
				<div>
					<!--<a class="btn btn-primary" :href="apiRoot+'outbound/product-checkout/'+$store.company.slug+'/'+product.stripe_price_id+'/'+customerStripeId">
						Purchase
					</a>
					-->
					<button type="button" class="btn btn-primary" v-on:click="selectPackage(product.stripe_price_id)">
						Select
					</button>
				</div>
			</div>

			<hr>
			<div v-if="product.callout_text" class="alert alert-warning text-center" style="font-size: 16pt">
				<i class="fa fa-star"></i>
				{{ product.callout_text }}
			</div>
			<div class="description" :class="{open: product.descriptionOpen}">
				<div class="fade-hider"></div>
				<div v-html="stripInlineEventHandlers(product.description)"></div>

			</div>
			<div class="text-center">
				<button v-if="!product.descriptionOpen" class="btn btn-light btn-sm" v-on:click="product.descriptionOpen = true">Read More</button>
				<button v-else class="btn btn-light btn-sm" v-on:click="product.descriptionOpen = false">
					<i class="fa fa-times"></i>
					Collapse
				</button>
			</div>
		</div>
	</widget>
	<form method="post" :action="$store.apiBase+'Product/checkout'" ref="cartForm">
		<input type="hidden" name="token" :value="$store.sessionToken">
		<input type="hidden" name="tenant_id" :value="$store.company.id">

		<input type="hidden" name="success_path" value="/setup/4">
		<input type="hidden" name="cancel_path" value="/setup/4">

		<input type="hidden" name="goToCheckout" value="true">

		<input type="hidden" id="cartItems" name="stripe_price_id_list" :value="cartJSON">
	</form>
</div>
<div v-else>

	<div class="text-center">
		<h2 style="color: var(--brand-primary-color);">Good Work!</h2>
		<p>You've just taken a postive step towards running your business more efficiently!</p>
		<h3>You Purchased the <em>{{ packagePurchased.title }}</em> Package</h3>

	</div>

	<!--
	<widget>
		<div class="description open">
			<div v-html="stripInlineEventHandlers(packagePurchased.description)"></div>
		</div>
	</widget>
	-->

</div>


</div>
</template>
<script type="text/javascript">

import Widget from "@/components/Widget"

export default {
	name: "OnboardingPackages",
	components: {
		Widget
	},
	data() {
		return {
			products: [],
			cartJSON: null
		}
	},
	computed: {
		packagePurchased() {
			if (+this.$store.company.onboarding_package_purchased_id > 0) {
				return this.products.find(prod => prod.id == this.$store.company.onboarding_package_purchased_id)
			}
			return false
		},
		customerStripeId() {
			if (this.$store.subscription) {
				return this.$store.subscription.stripe_id
			}
			return ""
		},
		localStorageCart() {
			return localStorage.getItem("cart")
		}
	},
	methods: {
		selectPackage(stripe_price_id) {
			let vm = this
			let localStorageCart = new Set() //use a set to handle removal of duplicates

			try {
				let cartFromLocalStorage = localStorage.getItem("cart")

				if (cartFromLocalStorage)
					localStorageCart = new Set(JSON.parse(cartFromLocalStorage))
			}
			catch (e) {}
			localStorageCart.add(stripe_price_id)

			localStorage.setItem('cart',JSON.stringify([...localStorageCart]))

			this.cartJSON = localStorage.getItem("cart")

			this.$nextTick(() => {
				vm.$refs.cartForm.submit()
			})
		},
		fetchCurrentSubscription() {
			let vm = this

			this.getJSON("Subscription/get",{},true).then(response => {
				if (response.success && response.data.length > 0) 
					vm.$store.subscription = response.data[0]
			})
		},
		fetchPackages() {
			let vm = this

			let filters = [
				["is_active",1]
			]

			let planIsFreeFlag = localStorage.getItem("planIsFree")

			if (planIsFreeFlag == 'false')
				filters.push(['price_cad >',0])

			let params = {
				filters,
				orders: [
					["price_cad","DESC"]
				]
			}

			this.getJSON("Product/get",params).then(response => {
				if (response.success) {
					vm.products = response.data.map(product => {
						product.descriptionOpen = false
						return product
					})
				}
			})
		}
	},
	created() {
		this.fetchPackages()
		this.fetchCurrentSubscription()
		this.fetchCompanyData()

		this.cartJSON = localStorage.getItem("cart")
	}
}
</script>

<style type="text/css">
	.price {
		font-size: 22pt;
		color: var(--brand-primary-color);
	}

	.inner {
		padding: 10px;
		padding-top: 0;
		margin-top: -10px;
	}

	.description {
		overflow: hidden;
		max-height: 100px;
		position: relative;
	}

	.fade-hider {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 80px;
		background: linear-gradient(transparent,white);
	}

	.description.open {
		max-height: none;
	}

	.description.open .fade-hider {
		display: none;
	}
</style>